import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import BaseLayout from '../../commons/BaseLayout';
import VaccinationPageAdult from './adult';


const VERSION_STORAGE_KEY = '@kitoApp/version';

export default function HomePage() {
  const [activeVersion, setActiveVersion] = useState(() => window.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult');

  return (
    <BaseLayout header headerLogo onVersionChange={setActiveVersion} sidebar>
      {activeVersion === 'Child' ? <Navigate to="/homepage" replace /> : <VaccinationPageAdult />}
    </BaseLayout>
  );
}
